// extracted by mini-css-extract-plugin
export default {"hidden":"style_hidden__bicbI"};